import { Button } from '@shared/ui';
import { IoReload } from 'react-icons/io5';
import './RefetchButton.css';

interface RefetchButtonProps {
    refetch: () => void;
    isLoading?: boolean;
    errorMessage?: string;
}

export default function RefetchButton({
    refetch,
    isLoading = false,
    errorMessage = 'Не удалось загрузить данные'
}: RefetchButtonProps) {
    return (
        <div className="refetch-button-container">
            <p className="refetch-button-message">{errorMessage}</p>
            <Button
                variant="primary"
                onClick={refetch}
                loading={isLoading}
                rightAddon={<IoReload />}
            >
                Повторить попытку
            </Button>
        </div>
    );
}

